import { createAsyncThunk } from '@reduxjs/toolkit';
import { INotification } from '../../api/types';
import { getTextError } from '../utils';
import {
  addNotification,
  changeNotification,
  readAllNotifications,
  removeAllNotifications,
  removeNotification,
} from './slice';
import { getNotifications, readNotification } from '../../api/notifications';

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const getNotificationsThunk = createAsyncThunk(
  'notifications/getNotifications',
  async (_, { rejectWithValue }) => {
    try {
      const notifications = (await getNotifications()).data.data;

      return notifications;
    } catch (error) {
      const textError = getTextError(error);
      return rejectWithValue(textError);
    }
  }
);

export const readNotificationThunk = createAsyncThunk(
  'notifications/readNotification',
  async (notification: INotification, { rejectWithValue, dispatch }) => {
    try {
      dispatch(changeNotification({ ...notification, readed_at: 'readed' }));

      const response = (await readNotification(notification.id)).data.data;

      if (response === 0) {
        dispatch(changeNotification({ ...notification, readed_at: null }));
      }
    } catch (error) {
      dispatch(changeNotification({ ...notification, readed_at: null }));

      const textError = getTextError(error);
      return rejectWithValue(textError);
    }
  }
);

export const readAllNotificationsThunk = createAsyncThunk(
  'notifications/readNotification',
  async (notifications: INotification[], { rejectWithValue, dispatch }) => {
    dispatch(readAllNotifications());

    notifications.forEach(async (notification) => {
      try {
        const response = (await readNotification(notification.id)).data.data;

        if (response === 0) {
          dispatch(changeNotification({ ...notification, readed_at: null }));
        }
      } catch (error) {
        dispatch(changeNotification({ ...notification, readed_at: null }));

        const textError = getTextError(error);
        return rejectWithValue(textError);
      }
    });
  }
);

export const removeNotificationThunk = createAsyncThunk(
  'notifications/removeNotification',
  async (notification: INotification, { rejectWithValue, dispatch }) => {
    try {
      dispatch(removeNotification(notification.id));

      await removeNotification(notification.id);
    } catch (error) {
      dispatch(addNotification(notification));

      const textError = getTextError(error);
      return rejectWithValue(textError);
    }
  }
);

export const removeAllNotificationsThunk = createAsyncThunk(
  'notifications/removeNotification',
  async (notifications: INotification[], { rejectWithValue, dispatch }) => {
    dispatch(removeAllNotifications());

    notifications.forEach((notification) => {
      try {
        removeNotification(notification.id);
      } catch (error) {
        dispatch(addNotification(notification));

        const textError = getTextError(error);
        return rejectWithValue(textError);
      }
    });
  }
);

export const clearServiceNotice = createAsyncThunk(
  'notifications/clearServiceNotice',
  async ({ id, sleepTime }: { id: string; sleepTime: number }, { rejectWithValue }) => {
    try {
      await sleep(sleepTime);

      return id;
    } catch (error) {
      const textError = getTextError(error);
      return rejectWithValue(textError);
    }
  }
);
